"use strict";
import initModulesInScope from '@elements/init-modules-in-scope';

export function initInScope ($scope) {
    let $shoeSizeInputs = $scope.find('.js-shoe-size__input');


    //Backlink
    let $backlink = $scope.find('.js-pds-backlink');
    $backlink.on('click', function (evt) {
        evt.preventDefault();
        if (document.referrer.includes('gabor.com') || document.referrer.includes('elements.zone')) {
            window.history.back();
        } else {
            window.location.href = $backlink.attr('data-href');
        }
    });


    //AB TEST wf_1621675
    if (matchMedia('(max-width: 767px)').matches) {

        let interval = setInterval(function(){

            //Version 1
            if($('body').hasClass('ab-pds-size-button')){
                let button = $('.js-sticky-add-to-cart-btn').find('.js-add-to-cart');
                if($('.js-shoe-size__selected').attr('hidden')){
                    button.html(button.data('ab-text'));
                    $('.pds-sticky-bar__col-btn').removeClass('col-7').addClass('col-12');
                    $('.pds-sticky-bar__col-price').addClass('d-none');
                } else {
                    button.html(button.data('ab-original-text'));
                }
                clearInterval(interval);
            }

            //Version 2
            if($('body').hasClass('ab-pds-size-dropup')){
                let button = $('.js-sticky-add-to-cart-btn').find('.js-add-to-cart');
                if($('.js-shoe-size__selected').attr('hidden')){
                    //find .js-sticky-add-to-cart-btn__size and move it to .pds-sticky-bar__col-price
                    let $priceContainer = $('.pds-sticky-bar__col-price');
                    let $sizeButton = $('.js-sticky-add-to-cart-btn__size');
                    $priceContainer.html('');
                    $sizeButton.removeAttr('hidden');
                    $priceContainer.append($sizeButton);
                    initModulesInScope($priceContainer);
                }
                clearInterval(interval);
            }
        }, 500);
    }

    $shoeSizeInputs.on('change', function() {
        let $this = $(this);
        let $wrapper = $this.closest('.js-shoe-size-wrapper');
        let $wishlistButton = $('.js-wishlist-btn');
        let selectedEuSize = $this.attr('data-eu-size');
        let $selectedSizeColor = $('.js-selected-size-color');

        //AB TEST wf_1621675
        if($('body').hasClass('ab-pds-size-button')){
            let button = $('.js-sticky-add-to-cart-btn').find('.js-add-to-cart');
            button.html(button.data('ab-original-text'));
        }

        // _cartConfig.cartAddUrl = $(e.target).data('carturl');

        //add attributes to wishlist button
        $wishlistButton.each(function(){
            $(this).attr('data-size', selectedEuSize);
            $(this).attr('data-product-id', $this.val());
        });

        // select shoe size input with same value
        $wrapper.find('.js-shoe-size__input').prop('checked', false);
        $wrapper.find('.js-shoe-size__input[value="'+ $this.val() +'"]').prop('checked', true);

        let $shoeSizeItem = $this.closest('.js-shoe-size');

        // change information for selected size in overlay-toggle-button
        $('.js-shoe-size__not-selected').attr('hidden', true);
        $('.js-shoe-size__selected').attr('hidden', false);
        $('.js-shoe-size__selected-size').html($shoeSizeItem.find('.js-shoe-size__text').html());

        // enable button if size is selected
        if($('.js-add-to-cart').hasClass('btn-cta--inital-disabled')) {
            $('.js-add-to-cart').removeClass('btn-cta--inital-disabled');
        }

        //add selected size to color button
        if($selectedSizeColor .length) {
            let href = $selectedSizeColor.attr('href');
            href = href.split('?')[0];
            href += '?size=' + selectedEuSize;
            $selectedSizeColor.attr('href', href);
        }

        // hurry up item
        $('.js-low-stock').attr('hidden', !$shoeSizeItem.data('low-stock'));

        // size advisor item
        $('.js-size-advisor-size').attr('hidden', $shoeSizeItem.data('size-advisor-size'));

        // size-notification item
        $('.js-size-notification').attr('hidden', !$shoeSizeItem.data('size-notification'));

        // disable add to cart button for not available sizes
        $('.js-add-to-cart').attr('disabled', !!$shoeSizeItem.data('size-notification'));

        // change price
        let price = $shoeSizeItem.data('osprice');
        if(!!price){
            $scope.find('.js-osprice').html(price);
        }
        let priceSale = $shoeSizeItem.data('ospricenosale');
        if(!!priceSale){
            $scope.find('.js-ospricenosale').html(priceSale)
        }

        /* ab saleprices wf_2046977 */
        let priceSaleCompare = $shoeSizeItem.data('compareprice');
        if(!!priceSaleCompare){
            priceSale = priceSaleCompare;
            $scope.find('.js-ospricenosale').html(priceSale)

            let priceSaleInt = parseInt(priceSale.replace(/[^0-9]/g, ''));
            let priceInt = parseInt(price.replace(/[^0-9]/g, ''));

            //get discount in percent and round it
            let discount = (1 - (priceInt / priceSaleInt)) * 100;

            let roundedDiscount = Math.round(discount);
            let discountText = '-' + roundedDiscount + '%';

            $('.js-pds-lazy-data-savings-target').html(discountText);
            $('.js-ospricenosale-discount').html(discountText);
        }

        /* size tracking */
        dataLayer.push({
            'event': 'genericGtmEvent',
            'genericEventCategory': $this.attr('data-gtm-category'),
            'genericEventAction': $this.attr('data-gtm-action'),
            'genericEventLabel': $this.attr('data-gtm-label'),
        });
    });
}